import * as React from 'react';
import { useState } from 'react';
import Container from 'reactstrap/lib/Container';
import {
    confirmLeaseUpload,
    ContactInfo,
    LeaseMatchResult,
    LeaseMatchType,
    LeaseUploadConfirmation,
    LeaseUploadStats
} from '../../../../api/Property';
import FormValidationDisplay from '../../../common/form/ValidationDisplay';
import LoadingOverlay from '../../../common/LoadingOverlay';
import LeaseMatchRow from './LeaseMatchRow';
import * as moment from 'moment';

interface Props {
    result: LeaseMatchResult[];
    propertyId: number;
    setModalOpen: (open: boolean) => void;
    setResultDisplay: (display: string) => void;
    setStatsDisplay: (stats: LeaseUploadStats) => void;
}

const LeaseMatchConfirmationTable = (props: Props) => {
    const [resultConfirmations, setResultConfirmations] = useState(
        props.result.map(result => result.matchType === LeaseMatchType.Exact)
    );
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

    const handleSubmit = async (
        propertyId: number,
        confirmedValues: ContactInfo[],
        originalExactMatches: number,
        originalBorderlineMatches: number,
        setModalIsOpen: (open: boolean) => void
    ) => {
        setIsLoading(true);
        const payload: LeaseUploadConfirmation = {
            acceptedCorrections: confirmedValues,
            originalExactMatches: originalExactMatches,
            originalBorderlineMatches: originalBorderlineMatches
        };

        const result = await confirmLeaseUpload(propertyId, payload);

        if (result.success) {
            setIsLoading(false);
            setModalIsOpen(false);
            props.setResultDisplay(
                `Upload Success: ${
                    payload.acceptedCorrections.length + payload.originalExactMatches
                } new matched tours`
            );
            props.setStatsDisplay({
                date: moment().format(),
                exactMatches: payload.originalExactMatches,
                borderlineMatches: payload.originalBorderlineMatches
            });
        } else {
            setIsLoading(false);
            setErrorMessage(result.error);
        }
    };

    return (
        <>
            <LoadingOverlay show={isLoading} inBootstrapColumn={false} />
            <Container className="lease-match-confirmation-table">
                <FormValidationDisplay errorMessage={errorMessage} />
                <h3>Application Match Results</h3>
                <header>
                    <p>Review and confirm any detected possible matches.</p>
                    <button className="btn btn-secondary" onClick={() => props.setModalOpen(false)}>
                        Cancel
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={() =>
                            handleSubmit(
                                props.propertyId,
                                props.result
                                    .filter((_, index) => resultConfirmations[index])
                                    .map(m => m.matchedData!),
                                props.result.filter(r => r.matchType === LeaseMatchType.Exact)
                                    .length,
                                props.result.filter(r => r.matchType === LeaseMatchType.Possible)
                                    .length,
                                (open: boolean) => props.setModalOpen(open)
                            )
                        }
                    >
                        Confirm
                    </button>
                </header>

                <table>
                    <thead>
                        <th>Submission</th>
                        <th>Submitted Email</th>
                        <th>Matched</th>
                        <th>Matched Email</th>
                        <th>Confirm?</th>
                    </thead>
                    <tbody>
                        {props.result.map((match, index) => (
                            <LeaseMatchRow
                                key={index}
                                match={match}
                                checked={resultConfirmations[index]}
                                setChecked={value =>
                                    setResultConfirmations(
                                        resultConfirmations.map(
                                            (existingValue, confirmationIndex) =>
                                                confirmationIndex !== index ? existingValue : value
                                        )
                                    )
                                }
                            />
                        ))}
                    </tbody>
                </table>
            </Container>
        </>
    );
};

export default LeaseMatchConfirmationTable;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/LeaseMatchConfirmationTable.tsx